import React from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Form, Field } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { Input } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { Button, Toolbar } from 'components'
import AuthActions from 'store/models/auth'
import schema from './schema'
import '../styles.scss'

const SignUp = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { loadingSignUp, signUpFailedErrorMessage } = useSelector(GET_STORE.AUTH)

    const onSubmit = ({ email, password }) => {
        dispatch(AuthActions.signUp(email, password, history))
    }

    return (
        <div className="landing-container">
            <Toolbar buttonTitle="Login" onButtonClicked={() => history.goBack()} />
            <div className="landing-card">
                <h1>Sign Up</h1>
                <Formik initialValues={{ email: '', password: '' }} validationSchema={schema} onSubmit={onSubmit}>
                    <Form>
                        <Field name="email">
                            {({ field, form, meta }) => <Input labelAbove="Work email" type="email" {...field} error={meta.error} touched={meta.touched} onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())} />}
                        </Field>
                        <Field name="password">
                            {({ field, meta }) => (
                                <Input labelAbove="Password" type="password" {...field} error={meta.error} touched={meta.touched} />
                            )}
                        </Field>
                        <Button loading={loadingSignUp} type="submit" className="landing-card-button">
                            SIGN UP
                        </Button>
                        {signUpFailedErrorMessage && <div className="input-error-label">*{signUpFailedErrorMessage}</div>}
                    </Form>
                </Formik>
            </div>
        </div>
    )
}

export default SignUp
